/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
import APM from '../APM';
import {IPerformanceMonitor, MonitorCategory} from '../types/types';
import PerformanceMonitor from './PerformanceMonitor';

/**
 * Defines the Initialization Performance Monitor implementation which is used
 * for measuring the Performance of initialization within an Application.
 *
 * Clients can simply import this module and invoke the `start` method to begin
 * monitoring a page. This is typically done via the application's initialization
 * actions module. Likewise, clients are to explicitly invoke the `stop` method
 * upon initialization completion, typically via the `initializationComplete`
 * action.
 *
 * ```typescript
 *   import getMonitor from '@ion/core/src/apm/InitializationPerformanceMonitor';
 * ```
 */
class InitializationPerformanceMonitor extends PerformanceMonitor {
  constructor() {
    super(MonitorCategory.Initialization);
  }
}

/**
 * Provides the single point of entry for referencing the single instance
 * of the `InitializationPerformanceMonitor`.
 */
const getMonitor = (() => {
  let instance: IPerformanceMonitor;
  return (): IPerformanceMonitor => {
    if (APM.isEnabled) {
      if (!instance) {
        instance = new InitializationPerformanceMonitor();
      }
    } else {
      instance = null;
    }
    return instance;
  };
})();

export default getMonitor;
